import * as PropTypes from 'prop-types';
import * as React from 'react';

import { mergeStyles } from '@cian/utils/lib/shared/style';

import { AlarmSVG } from '../../../common/components/description/icn-alarm';
import { IOffer } from '../../../types/offer';

import * as styles from './index.css';

export interface IPessimisationAPI {
  isBot: boolean;
}

export interface IPessimisationContext {
  api: { pessimisation: IPessimisationAPI; };
  offer: IOffer;
}

export interface IPessimisationProps {
  onComplainStateChanged(isComplainOpen: boolean): void;
}

export class Pessimisation extends React.Component<IPessimisationProps> {
  public context: IPessimisationContext;

  public static contextTypes = {
    api: PropTypes.object,
    offer: PropTypes.object,
  };

  public render() {
    let {
      isRecidivist,
      isExcludedFromAction,
    } = this.context.offer;

    if (this.context.api.pessimisation.isBot) {
      isRecidivist = false;
      isExcludedFromAction = false;
    }

    if (!isRecidivist && !isExcludedFromAction) {
      return null;
    }

    return (
      <div {...mergeStyles(
        styles['recidivist'],
        isExcludedFromAction && styles['excluded-from-action'],
      )}>
        <div className={styles['svg-container']}>
          <AlarmSVG />
        </div>
        {
          isRecidivist
            ? this.renderHardPessimisation()
            : isExcludedFromAction
              ? this.renderLightPessimisation()
              : null
        }
      </div>
    );
  }

  private handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation(); // не открываем объявление при клике на ссылку
  }

  private renderHelpLink = () => {
    return (
      <a className={styles['link']} href="/help/quality/37645/" target="_blank" onClick={this.handleLinkClick}>
        Подробнее
      </a>
    );
  }

  private renderHardPessimisation = () => {
    const complain =
      <span className={styles['complaint']} onClick={(e) => {
        e.stopPropagation();
        this.props.onComplainStateChanged(true);
      }}>
        оставьте жалобу
      </span>;

    return (
      <span className={styles['recidivist-description']} key="recidivistDescription">
        Этот агент замечен в размещении недостоверных предложений. Возможно, это объявление вымышленное.
        Служба качества ЦИАН не рекомендует звонить по этому объявлению. Если вы позвонили,
        но объекта нет, {complain}.
        {' '}
        {this.renderHelpLink()}
      </span>
    );
  }

  private renderLightPessimisation = () => {
    return (
      <span className={styles['recidivist-description']} key="excludedFromActionDescription">
        В объявлениях этого агента встречаются ошибки.
        Объект может отличаться от предложенного в объявлении.
        Уточняйте параметры объекта до просмотра. Оставьте жалобу, если обнаружите ошибку.
        {' '}
        {this.renderHelpLink()}
      </span>
    );
  }
}
